import { connect } from 'react-redux';
import PersonComment from './PersonComment';
import { AddPersonCommentBegin } from '../../../../store/actions/person.actions';
import { getPersonCommentList, getAddPersonCommentLoader } from '../../../../store/selectors/person.selectors';
const mapStateToProps = (state: any) => {
    const loading = getAddPersonCommentLoader(state);
    const personCommentList = getPersonCommentList(state);

    return {
        loading,
        personCommentList,
    };
};

const mapDispatchToProps = {
    addPersonComment: AddPersonCommentBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonComment);
